import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function SaveIcon({ color = RoutalPalette.white, props = {} }: { color?: string; props?: any }) {
  return (
    <SvgIcon {...props} viewBox="0 0 13 12" style={{ width: `13px`, height: `12px`, ...props.style }}>
      <path
        d="M9.46835 1.1792C9.4687 1.17956 9.46906 1.17991 9.46942 1.18026L11.3197 3.03055C11.3201 3.0309 11.3204 3.03126 11.3208 3.03162C11.5534 3.26794 11.6875 3.59265 11.6875 3.9175V10.375C11.6875 10.7997 11.3545 11.1527 10.9375 11.1851V6.875C10.9375 6.11761 10.3199 5.5 9.5625 5.5H3.4375C2.68011 5.5 2.0625 6.11761 2.0625 6.875V11.1851C1.64549 11.1527 1.3125 10.7997 1.3125 10.375V1.625C1.3125 1.20029 1.64549 0.847266 2.0625 0.814917V2.9375C2.0625 3.69489 2.68011 4.3125 3.4375 4.3125H7.375C8.13239 4.3125 8.75 3.69489 8.75 2.9375V0.823576C9.01946 0.859541 9.26832 0.982244 9.46835 1.1792Z"
        fill={color}
        stroke={color}
      />
      <path
        d="M9.0625 11.1875H3.9375V7.375H9.0625V11.1875ZM6.875 2.4375H3.9375V0.8125H6.875V2.4375Z"
        fill={color}
        stroke={color}
      />
    </SvgIcon>
  );
}
